import { FaMosque } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const navigate = useNavigate();

  const handleIconClick = () => {
    navigate("/");
  };

  return (
    <header className="header">
      <div className="header__container">
        <FaMosque className="header__icon" onClick={handleIconClick} />
        <h1 className="header__title">Chorulla Palli</h1>
        <p className="header__subtitle">"A Place of Blessings, A Meal for Everyone"</p>
      </div>
    </header>
  );
};

export default Header;
